import React from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { motion, AnimatePresence } from "framer-motion";

const Modal = ({ showModal, closeModal, children, className, dialogPanelClassName, preventOutsideClose = false, ...rest }) => {
  const handleClose = preventOutsideClose ? () => { } : closeModal;

  return (
    <AnimatePresence>
      {showModal && (
        <Dialog
          static
          open={!!showModal}
          onClose={handleClose}
          className={`relative z-[9999999999] ${className || ""}`}
          {...rest}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/30 modal-blockout"
          />

          <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
            <DialogPanel
              as={motion.div}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{
                opacity: 1,
                scale: 1,
              }}
              exit={{ opacity: 0, scale: 0.95 }}
              className={`max-w-lg bg-white p-12 ${dialogPanelClassName || ""}`}
            >
              {children}
            </DialogPanel>
          </div>
        </Dialog>
      )}
    </AnimatePresence>
  );
};

export default Modal;
